import { SELECTED_PLATFORM_STORAGE_KEY } from '../services/mma-config';
var getPlatform = function (platform) {
    return (sessionStorage.getItem(SELECTED_PLATFORM_STORAGE_KEY) ||
        platform);
};
export default getPlatform;
//# sourceMappingURL=getPlatform.js.map